import type { ReactNode } from "react";
import { useProfile } from "../hooks/profileQueries";
import { ProfileContext } from "./ProfileContext";

interface ProfileProviderProps {
  children: ReactNode;
}

export function ProfileProvider({ children }: ProfileProviderProps) {
  const { data: profile, isLoading, isError, error, refetch } = useProfile();

  return (
    <ProfileContext.Provider
      value={{
        profile,
        isLoading,
        isError,
        error,
        refetch,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
}
